/* Sheepskinhouse.nl cadeautrap (Be Yours-tema): 2+ artikelen = gratis Schapenvacht Borstel (NCL1308), 3+ artikelen = 10% orderkorting
   (Shopify Automatic "10% EXTRA KORTING - 3+ artikelen", min 4 eenheden incl. cadeauregel - wordt niet hier gestuurd).
   Stoelkussens (type 'Stoel Covers') tellen MEE in de trap bij 1-5 stuks; bij 6+ verbruikt de 6-halen-5-betalen-korting (16,67%) de eenheden.
   Be Yours-refresh: cart-drawer.refresh() / cart-items.refresh() - het thema regelt zelf sectie-rendering. */
(function () {
  var TIERS = [
    { min: 2, variant: 52215688692045 }
  ];
  var GIFT_VARIANTS = [52215688692045];
  var EXCLUDE_TYPE = 'Stoel Covers';
  var PROP = '_free_gift';
  var busy = false;

  function cartState(cart) {
    var giftLines = [], nonGiftQty = 0, hyndeQty = 0, variantPresent = {};
    (cart.items || []).forEach(function (it) {
      variantPresent[it.variant_id] = true;
      if (GIFT_VARIANTS.indexOf(it.variant_id) !== -1 && it.properties && it.properties[PROP]) giftLines.push(it);
      else if (it.product_type === EXCLUDE_TYPE) hyndeQty += it.quantity;
      else nonGiftQty += it.quantity;
    });
    if (hyndeQty > 0 && hyndeQty < 6) nonGiftQty += hyndeQty;
    return { giftLines: giftLines, nonGiftQty: nonGiftQty, variantPresent: variantPresent };
  }

  function refreshUI() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function') {
        var items = drawer.querySelector('cart-items');
        var needFull = !items || items.dataset.empty === 'true';
        drawer.refresh(needFull);
      }
      var pageItems = Array.prototype.slice.call(document.querySelectorAll('cart-items')).filter(function (el) { return !el.closest('cart-drawer'); })[0];
      if (pageItems) {
        if (pageItems.dataset.empty === 'true' || typeof pageItems.refresh !== 'function') { window.location.reload(); return; }
        pageItems.refresh();
      }
    } catch (e) { console.log('ns-gift refreshUI', e); }
  }

  function mutate(url, payload) {
    return fetch(url + '?ns_gift=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js?ns_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart);
      var target = null;
      for (var i = 0; i < TIERS.length; i++) { if (st.nonGiftQty >= TIERS[i].min) { target = TIERS[i]; break; } }

      var dismissedVar = sessionStorage.getItem('nsGiftDismissed') || '';
      var prevTier = sessionStorage.getItem('nsGiftTier') || '';

      if (target && prevTier === String(target.variant) && st.giftLines.length === 0 && !st.variantPresent[target.variant]) {
        sessionStorage.setItem('nsGiftDismissed', String(target.variant));
        dismissedVar = String(target.variant);
      }
      if (!target) { sessionStorage.removeItem('nsGiftDismissed'); dismissedVar = ''; }
      var dismissed = target && dismissedVar === String(target.variant);

      var ops = [];
      st.giftLines.forEach(function (gl) {
        if (!target || gl.variant_id !== target.variant) ops.push({ id: gl.key, quantity: 0 });
        else if (gl.quantity > 1) ops.push({ id: gl.key, quantity: 1 });
      });
      var needAdd = target && !st.variantPresent[target.variant] && !dismissed;

      var chain = Promise.resolve(null);
      ops.forEach(function (op) {
        chain = chain.then(function () { return mutate('/cart/change.js', { id: op.id, quantity: op.quantity }); });
      });
      if (needAdd) {
        chain = chain.then(function () {
          var props = {}; props[PROP] = '1';
          return mutate('/cart/add.js', { id: target.variant, quantity: 1, properties: props });
        });
      }

      chain.then(function () {
        sessionStorage.setItem('nsGiftTier', target ? String(target.variant) : '');
        if (ops.length || needAdd) refreshUI();
        busy = false;
      }).catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try {
      if (CART_MUTATION.test(url) && url.indexOf('ns_gift=1') === -1) {
        p.then(function () { setTimeout(reconcile, 200); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nsGiftUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try {
      var u = this.__nsGiftUrl || '';
      if (CART_MUTATION.test(u) && u.indexOf('ns_gift=1') === -1) {
        this.addEventListener('load', function () { setTimeout(reconcile, 200); });
      }
    } catch (e) {}
    return origSend.apply(this, arguments);
  };

  /* Quick-add knoppen (.ns-quickadd met data-variant) uit ns-gift-promo */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ns-quickadd') : null;
    if (!b) return;
    e.preventDefault();
    var v = parseInt(b.getAttribute('data-variant') || '', 10);
    if (!v) return;
    if (b.classList.contains('ns-qa-busy')) return;
    b.classList.add('ns-qa-busy');
    mutate('/cart/add.js', { id: v, quantity: 1 }).then(function (json) {
      b.classList.remove('ns-qa-busy');
      if (json) { refreshUI(); setTimeout(reconcile, 250); }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 400); });
  } else {
    setTimeout(reconcile, 400);
  }
})();
